$(document).ready(function () {
  $("details").on("mouseenter", function () {
    $("details").removeAttr("open");
    $(this).attr("open", true);
    $("details .header__menu-item").removeAttr("aria-expanded");
    $(this)
      .attr("open", true)
      .find(".header__menu-item")
      .attr("aria-expanded", true);
  });
  $("details").on("mouseleave", function () {
    $(this).removeAttr("open");
    $(this)
      .attr("open", false)
      .find(".header__menu-item")
      .removeAttr("aria-expanded");
  });
});

$(document).ready(function () {
  $("a.readless").parent(".col_description_content").hide();

  $(".readmore").click(function () {
    $(this).hide();
    $(this)
      .closest(".summary_content")
      .siblings(".col_description_content")
      .show();
  });

  $(".readless").click(function () {
    $(this).closest(".col_description_content").hide();
    $(this)
      .closest(".col_description_content")
      .siblings(".summary_content")
      .find(".readmore")
      .show();
  });
});
